(function () {
  'use strict';

  var PAGE_SIZE    = 3;
  // Show one short list, no paging. Raise MAX_POOL to bring the arrows back.
  var MAX_POOL     = 3;
  var REBUY_FLYOUT = 'div#fcd-drawer';
  var REBUY_WIDGET = '[data-rebuy-component="cross-sell-widget"]';
  var REBUY_BODY   = '.fcd-body';
  var WIDGET_ID    = 'fccs-widget';
  var RULES_URL    = '/cdn/shop/t/160048382171/assets/cross-sell-rules.json';

  var injected       = false;
  var rules          = null;
  var innerObs       = null;
  var lastHandles    = '';
  var lockedPicks    = null;   // randomized default-pool order, locked per candidate set
  var currentPool    = null;   // array of {handle, vmatch?} — availability-filtered
  var currentPoolKey = '';
  var currentPage    = 0;
  var renderSeq      = 0;      // guards against out-of-order async renders
  var productCache   = {};

  function injectStyles() {
    if (document.getElementById('fccs-styles')) return;
    var s = document.createElement('style');
    s.id = 'fccs-styles';
    s.textContent = [
      REBUY_WIDGET + '{display:none!important}',
      '#fccs-widget{background:#fff;padding:18px 0 4px;border-top:1px solid #ebe9e2}',
      '#fccs-widget .fccs-title{font-family:"Tenor Sans",Georgia,serif;font-size:14px;font-weight:400;color:#13322B;text-align:center;margin:0 0 14px;letter-spacing:.06em;text-transform:uppercase}',
      '#fccs-widget .fccs-item{display:grid;grid-template-columns:68px 1fr auto;align-items:center;gap:12px;padding:12px 16px;border-top:1px solid #f2f0ea;transition:background .15s}',
      '#fccs-widget .fccs-item:hover{background:#fbfbf8}',
      '#fccs-widget .fccs-img-link{display:block;width:68px;height:68px;flex-shrink:0}',
      '#fccs-widget .fccs-img{width:68px;height:68px;border-radius:8px;object-fit:cover;display:block;background:#f7f5f0}',
      '#fccs-widget .fccs-info{display:flex;flex-direction:column;gap:5px;min-width:0}',
      '#fccs-widget .fccs-name{font-size:12.5px;font-weight:500;color:#1a1a1a;line-height:1.4;text-decoration:none;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}',
      '#fccs-widget .fccs-name:hover{color:#13322B;text-decoration:underline}',
      '#fccs-widget .fccs-prices{display:flex;align-items:center;gap:6px}',
      '#fccs-widget .fccs-price{font-size:13px;font-weight:600;color:#13322B}',
      '#fccs-widget .fccs-compare{font-size:12px;color:#b3543f;text-decoration:line-through}',
      '#fccs-widget .fccs-select-wrap{position:relative;width:100%;margin-top:2px}',
      '#fccs-widget .fccs-select-wrap::after{content:"";position:absolute;right:9px;top:50%;transform:translateY(-50%);width:0;height:0;border-left:4px solid transparent;border-right:4px solid transparent;border-top:5px solid #13322B;pointer-events:none}',
      '#fccs-widget .fccs-select{display:block;font-size:12px;color:#1a1a1a;border:1px solid #d8d5cc;border-radius:6px;padding:6px 26px 6px 9px;background:#fff;cursor:pointer;width:100%;appearance:none;-webkit-appearance:none}',
      '#fccs-widget .fccs-select:focus{outline:none;border-color:#13322B}',
      '#fccs-widget .fccs-btn-col{display:flex;flex-direction:column;align-items:flex-end;gap:6px;min-width:70px}',
      '#fccs-widget .fccs-btn{height:34px;min-width:70px;padding:0 14px;border-radius:6px;font-size:12.5px;font-weight:500;cursor:pointer;border:none;transition:background .15s,transform .1s,opacity .15s;white-space:nowrap;text-align:center;letter-spacing:.01em}',
      '#fccs-widget .fccs-btn-add{background:#13322B;color:#fff}',
      '#fccs-widget .fccs-btn-add:hover{background:#0E271F}',
      '#fccs-widget .fccs-btn-add:active{transform:scale(.97)}',
      '#fccs-widget .fccs-btn-selected{background:#fff;color:#13322B;border:1.5px solid #13322B;cursor:default;pointer-events:none}',
      '#fccs-widget .fccs-btn-loading{opacity:.45;pointer-events:none}',
      '#fccs-widget .fccs-pager{display:flex;align-items:center;justify-content:center;gap:14px;padding:12px 16px 10px;border-top:1px solid #f2f0ea;margin-top:2px}',
      '#fccs-widget .fccs-pager[hidden]{display:none}',
      '#fccs-widget .fccs-page-num{font-size:12px;color:#6b6b6b;letter-spacing:.03em;min-width:44px;text-align:center}',
      '#fccs-widget .fccs-arrow{width:30px;height:30px;border-radius:50%;border:1px solid #d8d5cc;background:#fff;cursor:pointer;display:flex;align-items:center;justify-content:center;padding:0;transition:background .15s,border-color .15s,opacity .15s}',
      '#fccs-widget .fccs-arrow:hover:not(:disabled){background:#13322B;border-color:#13322B}',
      '#fccs-widget .fccs-arrow:hover:not(:disabled) svg{stroke:#fff}',
      '#fccs-widget .fccs-arrow:disabled{opacity:.3;cursor:default}',
      '#fccs-widget .fccs-arrow svg{width:13px;height:13px;display:block;stroke:#13322B;transition:stroke .15s}',
      '#fccs-widget .fccs-skel{background:linear-gradient(90deg,#f7f5f0 25%,#efece4 50%,#f7f5f0 75%);background-size:200% 100%;animation:fccs-shimmer 1.4s infinite;border-radius:6px}',
      '@keyframes fccs-shimmer{0%{background-position:200% 0}100%{background-position:-200% 0}}',
    ].join('');
    document.head.appendChild(s);
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  function pickRandomOnce(arr) {
    return arr.slice().sort(function () { return Math.random() - 0.5; });
  }

  function loadRules(cb) {
    if (rules) { cb(rules); return; }
    fetch(window.FCCS_RULES_URL || RULES_URL)
      .then(function (r) { return r.json(); })
      .then(function (d) { rules = d; cb(rules); })
      .catch(function () { cb({ default: [], campaigns: [] }); });
  }

  function getCart(cb) {
    if (window._fcdCart) { cb(window._fcdCart); return; }
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(cb)
      .catch(function () { cb({ items: [] }); });
  }

  function fetchProducts(handles, cb) {
    if (!handles.length) { cb({}); return; }
    var results = {};
    var queue   = [];
    handles.forEach(function (handle) {
      if (productCache[handle]) results[handle] = productCache[handle];
      else if (queue.indexOf(handle) === -1) queue.push(handle);
    });
    if (!queue.length) { cb(results); return; }
    var CHUNK = 5;
    var i = 0;
    function nextChunk() {
      if (i >= queue.length) { cb(results); return; }
      var batch = queue.slice(i, i + CHUNK);
      i += CHUNK;
      var remaining = batch.length;
      batch.forEach(function (handle) {
        fetch('/products/' + handle + '.js')
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (p) {
            if (p) { productCache[handle] = p; results[handle] = p; }
          })
          .catch(function () {})
          .finally(function () {
            if (--remaining === 0) setTimeout(nextChunk, 80);
          });
      });
    }
    nextChunk();
  }

  // Resolve pinned variant: exact title match first, then prefix match, else first available
  function resolveVariant(product, vmatch) {
    var variants = product.variants;
    if (vmatch) {
      var i;
      for (i = 0; i < variants.length; i++) {
        if (variants[i].title === vmatch) return variants[i];
      }
      for (i = 0; i < variants.length; i++) {
        if (variants[i].title.indexOf(vmatch) === 0) return variants[i];
      }
    }
    return variants.find(function (v) { return v.available; }) || variants[0];
  }

  function skeleton() {
    var rows = '';
    for (var i = 0; i < 3; i++) {
      rows += '<div class="fccs-item">' +
        '<div class="fccs-skel" style="width:68px;height:68px;border-radius:8px"></div>' +
        '<div class="fccs-info">' +
          '<div class="fccs-skel" style="height:12px;width:90%;margin-bottom:5px"></div>' +
          '<div class="fccs-skel" style="height:12px;width:65%;margin-bottom:8px"></div>' +
          '<div class="fccs-skel" style="height:12px;width:35%"></div>' +
        '</div>' +
        '<div class="fccs-btn-col"><div class="fccs-skel" style="width:70px;height:34px;border-radius:6px"></div></div>' +
      '</div>';
    }
    return '<p class="fccs-title">You May Also Like</p>' + rows;
  }

  function pagerHtml(page, totalPages) {
    return '<div class="fccs-pager"' + (totalPages <= 1 ? ' hidden' : '') + '>' +
      '<button type="button" class="fccs-arrow" data-page-prev aria-label="Previous products"' + (page <= 0 ? ' disabled' : '') + '>' +
        '<svg viewBox="0 0 24 24" fill="none" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>' +
      '</button>' +
      '<span class="fccs-page-num">' + (page + 1) + ' of ' + totalPages + '</span>' +
      '<button type="button" class="fccs-arrow" data-page-next aria-label="Next products"' + (page >= totalPages - 1 ? ' disabled' : '') + '>' +
        '<svg viewBox="0 0 24 24" fill="none" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>' +
      '</button>' +
    '</div>';
  }

  function buildCard(product, inCart, vmatch) {
    var pinned    = resolveVariant(product, vmatch);
    var available = product.variants.filter(function (v) { return v.available; });
    var price     = formatMoney(pinned.price);
    var compare   = pinned.compare_at_price && pinned.compare_at_price > pinned.price
                      ? formatMoney(pinned.compare_at_price) : '';
    var img       = (pinned.featured_image && pinned.featured_image.src) || product.featured_image || '';

    // Dropdown only when there's a real choice between in-stock variants
    var selectHtml = '';
    if (available.length > 1) {
      var opts = available.map(function (v) {
        return '<option value="' + v.id + '"' + (v.id === pinned.id ? ' selected' : '') + '>' +
          v.title + '</option>';
      }).join('');
      selectHtml = '<div class="fccs-select-wrap"><select class="fccs-select" data-variant-select>' + opts + '</select></div>';
    }

    var btnHtml = inCart
      ? '<button class="fccs-btn fccs-btn-selected" disabled>Selected</button>'
      : '<button class="fccs-btn fccs-btn-add" data-variant-id="' + pinned.id + '">Add</button>';

    return '<div class="fccs-item" data-handle="' + product.handle + '">' +
      '<a class="fccs-img-link" href="/products/' + product.handle + '">' +
        '<img class="fccs-img" src="' + img + '" alt="' + product.title + '" loading="lazy" width="68" height="68">' +
      '</a>' +
      '<div class="fccs-info">' +
        '<a class="fccs-name" href="/products/' + product.handle + '">' + product.title + '</a>' +
        '<div class="fccs-prices">' +
          '<span class="fccs-price">' + price + '</span>' +
          (compare ? '<span class="fccs-compare">' + compare + '</span>' : '') +
        '</div>' +
        selectHtml +
      '</div>' +
      '<div class="fccs-btn-col">' + btnHtml + '</div>' +
    '</div>';
  }

  function addToCart(variantId, btn) {
    btn.textContent = '...';
    btn.classList.add('fccs-btn-loading');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
      .then(function () {
        btn.textContent = 'Selected';
        btn.className = 'fccs-btn fccs-btn-selected';
        btn.disabled = true;
        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cartData) {
            window._fcdCart = cartData;
            if (typeof window.fcdRenderCart === 'function') {
              window.fcdRenderCart(cartData);
            }
            // Nudge fcd-subscriptions (and anything else watching the cart)
            // so Subscribe & Save selectors get injected on the new line item.
            try {
              document.dispatchEvent(new CustomEvent('rebuy:cart.change', { detail: { cart: cartData } }));
            } catch (e) {}
          });
      })
      .catch(function () {
        btn.textContent = 'Add';
        btn.classList.remove('fccs-btn-loading');
      });
  }

  function attachListeners() {
    var widget = document.getElementById(WIDGET_ID);
    if (!widget) return;

    widget.querySelectorAll('.fccs-btn-add').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item      = btn.closest('.fccs-item');
        var sel       = item ? item.querySelector('[data-variant-select]') : null;
        var variantId = sel ? parseInt(sel.value, 10) : parseInt(btn.dataset.variantId, 10);
        addToCart(variantId, btn);
      });
    });

    widget.querySelectorAll('[data-variant-select]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var item = sel.closest('.fccs-item');
        if (!item) return;
        var btn = item.querySelector('.fccs-btn-add');
        if (btn) btn.dataset.variantId = sel.value;

        // Keep the thumbnail and price in step with the chosen variant
        var product = productCache[item.dataset.handle];
        if (!product) return;
        var v = product.variants.find(function (x) { return String(x.id) === String(sel.value); });
        if (!v) return;

        var imgEl = item.querySelector('.fccs-img');
        if (imgEl) imgEl.src = (v.featured_image && v.featured_image.src) || product.featured_image || '';

        var priceEl = item.querySelector('.fccs-price');
        if (priceEl) priceEl.textContent = formatMoney(v.price);

        var prices = item.querySelector('.fccs-prices');
        var cmpEl  = item.querySelector('.fccs-compare');
        if (v.compare_at_price && v.compare_at_price > v.price) {
          if (!cmpEl) {
            cmpEl = document.createElement('span');
            cmpEl.className = 'fccs-compare';
            if (prices) prices.appendChild(cmpEl);
          }
          cmpEl.textContent = formatMoney(v.compare_at_price);
        } else if (cmpEl) {
          cmpEl.remove();
        }
      });
    });

    var prev = widget.querySelector('[data-page-prev]');
    var next = widget.querySelector('[data-page-next]');
    if (prev) prev.addEventListener('click', function () {
      if (currentPage > 0) { currentPage--; renderPage(); }
    });
    if (next) next.addEventListener('click', function () {
      var total = Math.ceil((currentPool || []).length / PAGE_SIZE);
      if (currentPage < total - 1) { currentPage++; renderPage(); }
    });
  }

  function renderButtons(cartHandles) {
    var widget = document.getElementById(WIDGET_ID);
    if (!widget) return;
    widget.querySelectorAll('.fccs-item').forEach(function (item) {
      var handle = item.dataset.handle;
      var btn    = item.querySelector('.fccs-btn');
      if (!btn || btn.classList.contains('fccs-btn-loading')) return;
      var inCart = cartHandles.indexOf(handle) !== -1;
      if (inCart && !btn.classList.contains('fccs-btn-selected')) {
        btn.textContent = 'Selected';
        btn.className   = 'fccs-btn fccs-btn-selected';
        btn.disabled    = true;
      } else if (!inCart && btn.classList.contains('fccs-btn-selected')) {
        btn.textContent = 'Add';
        btn.className   = 'fccs-btn fccs-btn-add';
        btn.disabled    = false;
      }
    });
  }

  function renderPage() {
    var widget = document.getElementById(WIDGET_ID);
    if (!widget || !currentPool) return;
    if (!currentPool.length) { widget.innerHTML = ''; return; }

    var totalPages = Math.ceil(currentPool.length / PAGE_SIZE);
    if (currentPage > totalPages - 1) currentPage = totalPages - 1;
    if (currentPage < 0) currentPage = 0;

    var entries = currentPool.slice(currentPage * PAGE_SIZE, (currentPage + 1) * PAGE_SIZE);

    getCart(function (cartData) {
      try {
        var cartHandles = cartData.items.map(function (i) { return i.handle; });
        var w = document.getElementById(WIDGET_ID);
        if (!w) return;
        var html = entries.map(function (e) {
          var p = productCache[e.handle];
          if (!p) return '';
          return buildCard(p, cartHandles.indexOf(e.handle) !== -1, e.vmatch || null);
        }).join('');
        w.innerHTML = '<p class="fccs-title">You May Also Like</p>' + html + pagerHtml(currentPage, totalPages);
        attachListeners();
      } catch (e) { /* never break the drawer */ }
    });
  }

  // One campaign per cart, like Selleasy: walk cart items in order and take the
  // first campaign whose triggers contain that item. Fall back to default pool.
  function buildPool(r, cartItems) {
    var cartHandles = cartItems.map(function (i) { return i.handle; });
    var campaign = null;
    for (var i = 0; i < cartItems.length && !campaign; i++) {
      var h = cartItems[i].handle;
      campaign = (r.campaigns || []).find(function (c) {
        return (c.triggers || []).indexOf(h) !== -1;
      }) || null;
    }

    if (campaign) {
      var pool = [];
      var seen = {};
      (campaign.offers || []).forEach(function (o) {
        var entry = typeof o === 'string' ? { handle: o } : o;
        if (seen[entry.handle]) return;
        if (cartHandles.indexOf(entry.handle) !== -1) return;
        seen[entry.handle] = true;
        pool.push(entry);
      });
      return { pool: pool, key: 'c:' + campaign.name + ':' + pool.map(function (e) { return e.handle; }).join(',') };
    }

    var candidates = (r.default || [])
      .map(function (o) { return typeof o === 'string' ? { handle: o } : o; })
      .filter(function (e) { return e && e.handle && cartHandles.indexOf(e.handle) === -1; });
    var candKey = candidates.map(function (e) { return e.handle; }).sort().join(',');
    if (!lockedPicks || lockedPicks._key !== candKey) {
      lockedPicks = pickRandomOnce(candidates);
      lockedPicks._key = candKey;
    }
    var dp = lockedPicks.filter(function (e) { return e && e.handle; });
    return { pool: dp, key: 'd:' + dp.map(function (e) { return e.handle; }).join(',') };
  }

  function loadAndRender(forceRefresh) {
    loadRules(function (r) {
      getCart(function (cartData) {
        // Empty cart: show nothing
        if (!cartData.items.length) {
          lastHandles = '';
          currentPool = [];
          currentPoolKey = '';
          var w = document.getElementById(WIDGET_ID);
          if (w) w.innerHTML = '';
          return;
        }

        var cartHandles = cartData.items.map(function (i) { return i.handle; });
        var handlesKey  = cartHandles.slice().sort().join(',');

        if (!forceRefresh && handlesKey === lastHandles && currentPool) {
          renderButtons(cartHandles);
          return;
        }
        lastHandles = handlesKey;

        var built = buildPool(r, cartData.items);
        var seq   = ++renderSeq;

        // Prefetch every pool product so sold-out items can be filtered
        // out before pagination (pages stay stable while browsing).
        fetchProducts(built.pool.map(function (e) { return e.handle; }), function (byHandle) {
          if (seq !== renderSeq) return;
          var filtered = built.pool.filter(function (e) {
            var p = byHandle[e.handle];
            if (!p || !p.available) return false;
            var v = resolveVariant(p, e.vmatch || null);
            return !!(v && v.available);
          });
          var key = built.key + '|n:' + filtered.length;
          if (key !== currentPoolKey) {
            currentPoolKey = key;
            currentPage    = 0;
          }
          currentPool = filtered.slice(0, MAX_POOL);
          renderPage();
        });
      });
    });
  }

  function inject() {
    if (injected) return;
    try {
      var drawer = document.querySelector(REBUY_FLYOUT);
      var body   = drawer ? drawer.querySelector(REBUY_BODY) : null;
      if (!drawer || !body) return;
      var widget = document.createElement('div');
      widget.id  = WIDGET_ID;
      widget.innerHTML = skeleton();
      // Live OUTSIDE .fcd-body so fcdRenderCart's rewrites never touch or
      // trip over our markup: prefer .fcd-extras, else sibling after body.
      var extras = drawer.querySelector('.fcd-extras');
      if (extras) extras.appendChild(widget);
      else body.insertAdjacentElement('afterend', widget);
      injected = true;
      loadAndRender(true);
    } catch (e) { /* never break the drawer */ }
  }

  function watchInsideCart(anchor) {
    if (innerObs) { innerObs.disconnect(); innerObs = null; }
    innerObs = new MutationObserver(function () {
      if (!document.getElementById(WIDGET_ID)) {
        injected = false;
        setTimeout(inject, 100);
      }
    });
    innerObs.observe(anchor, { childList: true, subtree: true });
  }

  function watchCart() {
    var obs = new MutationObserver(function () {
      var flyout = document.querySelector(REBUY_FLYOUT);
      if (!flyout) return;
      var isOpen = flyout.classList.contains('is-open');
      if (isOpen) {
        var anchor = flyout.querySelector(REBUY_BODY);
        if (anchor && !injected) {
          setTimeout(function () { inject(); watchInsideCart(flyout); }, 200);
        }
      } else {
        if (innerObs) { innerObs.disconnect(); innerObs = null; }
        var w = document.getElementById(WIDGET_ID);
        if (w) w.remove();
        injected = false;
        // Keep pool/page state — same products and page show on next open
      }
    });
    obs.observe(document.body, {
      childList: true, subtree: true,
      attributes: true, attributeFilter: ['class', 'style']
    });
  }

  function init() {
    injectStyles();
    watchCart();

    document.addEventListener('fcd:cart:handles:changed', function () {
      if (injected) loadAndRender(true);
    });

    document.addEventListener('theme:cart:change', function () {
      if (!injected) return;
      getCart(function (cartData) {
        var cartHandles = cartData.items.map(function (i) { return i.handle; });
        renderButtons(cartHandles);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();